import React from 'react';

const RANK_ICONS_MAP = {
  Unranked: 'Unranked.png',
  Gold_1: 'Gold_1.png',
};

type Rank = keyof typeof RANK_ICONS_MAP;

const RankBadge = React.memo(({ rank }: { rank: Rank; }) => {
  const [badge, setBadge] = React.useState('');

  if (badge === '') {
    import(`./badges/${RANK_ICONS_MAP[rank]}`)
      .then((result) => setBadge(result.default));
  }

  if (!badge) {
    return null;
  }

  return <img src={badge} alt={rank} />;
}, (prevProps, nextProps) => prevProps.rank === nextProps.rank);

export default RankBadge;
